export { LatestMonthlyReportsWidget } from './LatestMonthlyReportsWidget';
